<template>
  <div>
    <div class="add-image-from-url">
      <div @click="isShowFromURL = true">Add image from URL</div>
    </div>
    <div class="container-upload" :style="{ minHeight: height + 'px' }">
      <div v-if="isLoading" class="loading-upload">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <div v-else-if="!image || !image.imageSrc" class="placeholder-upload" @click="uploadFile">
        <div class="text-center">
          <v-icon>mdi-upload</v-icon>
          <p>Upload image here</p>
          <input
            style="display: none"
            class="hidden"
            type="file"
            ref="inputImage"
            accept="image/gif, image/jpeg, image/png , image/jpg, image/webp"
            @change="onChangeImage"
          />
        </div>
      </div>

      <div v-else-if="image && image.imageSrc && typeUpload == 'image'" class="image-upload">
        <img
          class="image-upload-item"
          :src="imageHelpers.url(image.imageSrc, { width: width, height: height })"
          alt=""
        />
        <div class="action-upload">
          <v-btn icon @click="isShowImage = true">
            <v-icon size="20">mdi-eye</v-icon>
          </v-btn>
          <v-btn icon @click="removeUpload">
            <v-icon size="20">mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>
      <v-dialog v-model="isShowImage" max-width="900">
        <v-card>
          <div class="d-flex justify-center">
            <img loading="eager" :src="imageHelpers.url(image.imageSrc, { width: width, height: height })" alt="" />
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isShowFromURL" max-width="900">
        <v-card>
          <v-card-title>Add image from URL</v-card-title>
          <v-card-text>
            <v-text-field v-model="urlImage" label="URL" />
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn text color="primary" @click="isShowFromURL = false">Cancel</v-btn>
            <v-btn text color="primary" @click="onAddImageFromURL">Add Image</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import imageHelpers from '@/helpers/image';
import './upload-image.scss';
import { uploadService } from '@/apis/upload.s';

export default {
  props: {
    subTitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Image',
    },
    typeUpload: {
      type: String,
      default: 'image',
    },
    image: {
      type: Object,
      default: () => {},
    },
    itemSetData: {
      type: Object,
      default: () => {},
    },
    height: {
      type: String,
      default: '350',
    },
    width: {
      type: String,
      default: '300',
    },
    widthParam: {
      type: String,
      default: '1000',
    },
    qualityParam: {
      type: String,
      default: '100',
    },
  },
  data() {
    return {
      isLoading: false,
      isShowImage: false,
      imageHelpers: imageHelpers,
      isShowFromURL: false,
      urlImage: '',
    };
  },
  methods: {
    optimizeImageSrc(rawSrc) {
      const src = (rawSrc || '').trim();
      if (!src) return src;

      const isDev = process.env.NODE_ENV === 'development';
      if (isDev) return src;

      try {
        const url = new URL(src, window.location.origin);
        const match = url.pathname.match(/\/images\/(.+)/);
        if (!match) return src;

        let optimizedSrc = `/uploads/images/${match[1]}`;

        if (url.searchParams.has('q')) {
          optimizedSrc += `?w=${this.widthParam}&q=${this.qualityParam}`;
        }

        return optimizedSrc;
      } catch (e) {
        return src;
      }
    },
    checkFileType(file) {
      // để 4 loại file dưới thì hiện ảnh, khác thì hiện tên
      if (file) {
        if (
          file.includes('.png') ||
          file.includes('.jpg') ||
          file.includes('.jpeg') ||
          file.includes('.gif') ||
          file.includes('.webp')
        ) {
          return true;
        }
        return false;
      }
    },
    onAddImageFromURL() {
      const rawUrl = (this.urlImage || '').trim();
      if (!rawUrl) {
        this.isShowFromURL = false;
        this.urlImage = '';
        return;
      }
      const optimizedSrc = this.optimizeImageSrc(rawUrl);

      this.$emit(
        'callback',
        {
          alt: optimizedSrc,
          alt_text: optimizedSrc,
          imageSrc: optimizedSrc,
          _id: this.objectId(),
        },
        this.itemSetData,
        'image',
      );
      this.isShowFromURL = false;
      this.urlImage = '';
    },
    async onChangeImage(e) {
      var _URL = window.URL || window.webkitURL;
      let img = new Image();
      let file = e.target.files[0];
      // Check file size (5MB = 5 * 1024 * 1024)
      if (file.size > 5 * 1024 * 1024) {
        this.$store.dispatch('setMessage', { color: 'red', dialog: true, content: 'File must be less than 5MB!' });
        return false;
      }
      img.src = _URL.createObjectURL(file);
      try {
        let type = file.name.split('.')[file.name.split('.').length - 1];
        let id = this.objectId();
        this.isLoading = true;
        let resGetImage = await uploadService.get({ filename: `image-${id}.${type}` });
        if (resGetImage) {
          await axios.put(resGetImage.data.presignedUrl, file, {
            headers: {
              'Content-Type': `image/${type}`,
              // 'Content-Type': file.type || 'application/octet-stream',
            },
          });

          const imageSrc = imageHelpers.url(resGetImage.data.imagePath);
          const optimizedSrc = this.optimizeImageSrc(imageSrc);

          const obj = {
            alt: file.name,
            alt_text: file.name,
            imageSrc: optimizedSrc,
            _id: id,
          };

          if (this.typeUpload === 'image') {
            // với 4 loại file ảnh
            this.$emit('callback', obj, this.itemSetData, 'image');
          } else {
            // với tất cả các loại
            this.$emit('callback', obj, this.itemSetData, '');
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },
    objectId() {
      return this.hex(Date.now() / 1000) + ' '.repeat(16).replace(/./g, () => this.hex(Math.random() * 16));
    },
    removeUpload() {
      // giống onChangeImage()
      if (this.typeUpload === 'image') {
        this.$emit('callbackDelete', this.itemSetData, 'image');
      } else {
        this.$emit('callbackDelete', this.itemSetData, '');
      }
    },
    hex(value) {
      return Math.floor(value).toString(16);
    },
    uploadFile() {
      this.$refs.inputImage.click();
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.add-image-from-url {
  color: var(--v-primary-base, #2977ff);
  font-size: 14px;
  font-weight: 500;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
  > div {
    cursor: pointer;
  }
}
</style>
